import React from 'react';
export function FloatingCTA() {
  return <>
      <style data-id="element-165">{`
        @keyframes pulseScaleOnly {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
      `}</style>
      <div className="fixed bottom-4 left-4 right-4 z-[9999]" data-id="element-166">
        <div className="max-w-[500px] mx-auto" data-id="element-167">
          <a href="https://cocinaydulcesrentables.com/cart/54079778619676:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#4caf50] hover:bg-[#43a047] text-white font-['Montserrat',_sans-serif] font-bold text-base md:text-lg uppercase py-4 rounded-full transition-colors shadow-[0_8px_24px_rgba(0,0,0,0.3)] text-center" style={{
          animation: 'pulseScaleOnly 1.5s ease-in-out infinite'
        }} data-id="element-168">
            🔥 ¡QUIERO MI ACCESO AHORA! - $6.900 🔥
          </a>
        </div>
      </div>
    </>;
}